<template>
  <v-navigation-drawer
    v-model="drawer"      
    app
    right
    width="550"
    temporary
    hide-overlay
  >
    <v-toolbar
      color="tertiary lighten-3" 
      dark
    >
      <v-toolbar-title class="white--text">
        Advanced Filter
      </v-toolbar-title>
    </v-toolbar>
    <v-container> 
      <v-row>
        <v-col cols="12"> 
          <v-autocomplete
            v-model="searchSelected.branches"
            :items="branches"              
            label="Branch"
            placeholder="Branch Filter"
            item-text="branch_name"
            item-value="branch_uid"              
            background-color="white"
            clearable
            hide-no-data
            hide-selected
            chips
            multiple
            filled
            @change="filterBranches"
          >
            <template v-slot:selection="data">
              <v-chip
                :input-value="data.selected"
                close
                class="chip--select-multi"
                @click:close="removeBranch('branches', data.item)"
              >
                {{ data.item.branch_name }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12"> 
          <v-autocomplete
            v-model="searchSelected.departments"
            :items="departments"              
            label="Department"
            placeholder="Department Filter"
            item-text="name"
            item-value="id"              
            background-color="white"
            clearable
            hide-no-data
            hide-selected
            chips
            deletable-chips
            multiple
            filled
            @change="filterDepartments"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-navigation-drawer>
</template>

<script>
  export default {
    data () {
      return {
        drawer: null,
        searchSelected: {
          branches: [],
          departments: [],
        },
        branches: [],
        departments: [],
      }
    },
    created () {
      this.loadData()  
    },
    methods: {
      loadData () {
        this.loadBranches()
        this.loadDepartments()
      },
      filterBranches (val) {
        this.$emit('branches-filter', val)
      },
      filterDepartments (val) {
        this.$emit('departments-filter', val)
      },
      removeBranch (key, item) {
        let index = this.searchSelected[key].findIndex(selectedId => selectedId === item.branch_uid)

        if (index >= 0) this.searchSelected[key].splice(index, 1)
      }, 
      loadBranches () {
        this.$api.branches().list()
          .then(response => {
            this.branches = response.data
          }) 
      },
      loadDepartments () {
        this.$api.departments().list(['name'])
          .then(response => {
            this.departments = response.data
          })
      },
    },
  }
</script>
